import InputMask from "react-input-mask";
import NumberFormat from "react-number-format";
import { useField, useFormikContext } from "formik";
import React, { useImperativeHandle, useRef, useState } from "react";
// @ts-ignore
import stringMask from "string-mask";
import { inputTypes } from "../../../common/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { RootStateType } from "../../../store/RootState";
import { get } from "http";


type Props = {
  label?: string,
  isRequired?: boolean,
  requiredText?: boolean,
  clearable?: boolean,
  defaultValue?: any,
  value?: any,
  definition?: string,
  required?: boolean,
  type?: inputTypes,
  mask?: string,
  currencyformat?: any,
  error?: any,
  currencyicon?: boolean | string,
  rightIcon?: React.ReactNode,
  labelHelper?: string,
  className?: string,
  successText?: string,
  name?: string,
  maxLength?: number,
  placeholder?: string,
  disabled?: boolean,
  showPasswordIcon?: boolean,
  labelInfoIcon?: React.ReactElement,
  currencyId?: number
}
const Input = React.forwardRef(({ label, isRequired, requiredText, clearable, ...props }: Props | any, ref) => {
  const currencyList = useSelector((state: RootStateType) => state.firmCurrencyList.currencyList);
  const [field, meta] = useField(props);
  const maskRef = useRef<any>();
  const { setFieldValue, setFieldTouched } = useFormikContext();
  const [showPassword, setShowPassword] = useState(false);

  useImperativeHandle(ref, () => ({

    setValue(val: any) {
      setInputValue(val);
    }
  }));

  const setInputValue = (val: any) => {

    if (props.mask) {
      var mask = new stringMask(props.mask, {}); //optionsObject is optional
      var maskedValue = mask.apply(val);
      setFieldValue(field.name, maskedValue);
    } else {
      setFieldValue(field.name, val);
    }
  }

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const getCurrencySymbol = () => {
    if (props.currencyId > 0) {
      const currency = currencyList.find(c => c.currencyId === props.currencyId);
      return currency ? currency.currencySymbol : "";
    }
    else{
      return "₺";
    }
  }

  return (
    <div>
      {label && (
        <div className="flex items-center text-sm mb-1">
          <label className="block text-contrast-70 whitespace-nowrap cursor-default">
            {label}
          </label>
          {props.definition && (
            <p className="block text-contrast-70 text-darkblue-400 whitespace-nowrap ml-1">
              ({props.definition})
            </p>
          )}
          {props.required && <p className="block text-contrast-70">*</p>}
          {props.labelInfoIcon ? props.labelInfoIcon : null}
        </div>
      )}

      {props.type === "textarea" ? (
        <textarea
          {...field}
          {...props}
          className={`border-b text-contrast-90 text-sm  rounded-md-custom  leading-4 h-8 p-2 bg-contrast-10 border-gray-300 mr-2 focus:outline-none w-full  ${props.className
            } ${meta.touched && meta.error ? "border-error" : "border-gray-300"}`}
        ></textarea>
      ) : props.mask ? (
        <InputMask
          ref={maskRef}
          {...field}
          {...props}
          mask={props.mask}
          maskChar={null}
          className={`border-b text-contrast-90 text-sm rounded-md-custom  leading-3 h-8 p-2 bg-contrast-10   mr-2 focus:outline-none w-full ${props.className
            } ${props.error && "border-error"} ${meta.touched && meta.error ? "border-error" : "border-gray-300"
            }`}
        />
      ) : props.currencyformat ? (
        <div className="w-full relative">
          <NumberFormat
            {...field}
            {...props}
            type="text"
            thousandSeparator={true}
            decimalSeparator={"."}
            decimalScale={2}
            fixedDecimalScale={true}
            allowNegative={false}
            defaultValue={props.defaultValue}
            className={`border-b text-contrast-90 text-sm rounded-md-custom  leading-4 h-8 p-2 bg-contrast-10   mr-2 focus:outline-none w-full  ${props.className
              } ${meta.touched && meta.error
                ? "border-error"
                : props.error
                  ? "border-error"
                  : "border-gray-300"
              }   
            `}
          />
          {props.currencyicon && (
            <span className="absolute z-2 right-6 top-1.5  text-contrast-50">
              {getCurrencySymbol()}
            </span>
          )}
        </div>
      ) : (
        <div className={`w-full relative ${props.rightIcon ? "flex items-center" : ""}`}>
          <input
            {...field}
            {...props}
            type={props.type === "password" && showPassword ? "text" : props.type}
            style={{ display: '-ms-reveal-none' }}
            className={`border-b  text-contrast-90 rounded-md-custom text-sm leading-3 h-8 p-2 bg-contrast-10  mr-2 focus:outline-none w-full ${props.className
              }  ${meta.touched && meta.error
                ? "border-error"
                : props.error
                  ? "border-error"
                  : "border-gray-300"
              }   `}
          />
          {props.showPasswordIcon && props.type === "password" && (
            <span
              className="absolute z-2 right-6 top-1.5 text-contrast-50"
            >
              <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} className="cursor-pointer" onClick={togglePasswordVisibility} />
            </span>
          )}
          {props.currencyicon && (
            <span className="absolute z-2 right-6 top-1.5  text-contrast-50">
              ₺
            </span>
          )}
          {(clearable && field.value) ? (
            <span className="absolute z-2 right-0 top-1.5   text-contrast-50">

              <FontAwesomeIcon icon={faXmark} className="cursor-pointer mr-2" fontSize={18} onClick={() => {
                setInputValue("");
              }} />
            </span>
          ) : null}
          {props.rightIcon && (
            <div className=" z-2 text-contrast-50 color-primary-color h-full bg-contrast-10 rounded-md h-8 flex items-center w-[36px] justify-center">
              {props.rightIcon}
            </div>
          )}
        </div>
      )}
      {props.labelHelper && (
        <p className="mt-2 text-2xs text-contrast-70">{props.labelHelper}</p>
      )}
      {(meta.touched && meta.error) && (
        <p className="mt-2 text-sm text-error-text">{meta.error}</p>
      )}
      {props.successText && (
        <p className="mt-2 text-sm text-success-text">{props.successText}</p>
      )}
    </div>
  );
})


export default Input;